export default function LocationIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14.971" height="21.388" viewBox="0 0 14.971 21.388">
    <path id="Icon_material-location-on" data-name="Icon material-location-on" d="M14.986,3A7.48,7.48,0,0,0,7.5,10.486c0,5.614,7.486,13.9,7.486,13.9s7.486-8.288,7.486-13.9A7.48,7.48,0,0,0,14.986,3Zm0,10.159a2.673,2.673,0,1,1,2.673-2.673A2.674,2.674,0,0,1,14.986,13.159Z" transform="translate(-7.5 -3)"/>
  </svg>
  ;
}